(function() {
    'use strict';

    angular.module('conferencesApp').service('WSAlert', function ($timeout, $location, $anchorScroll) {

        var scrollOffset = 75;

        var addMessage = function (type) {

            return function (title, text, displayed) {

                var msg = {
                    type: type,
                    title: title,
                    text: text,
                    displayed: displayed || false
                };

                this.messages.push(msg);

                // scroll to alerts
                $('body,html').animate({scrollTop: Math.max(0, $('#ws-alert-scroll-anchor').offset().top - scrollOffset)});
            };
        };

        this.messages = [];
        this.success = addMessage('success');
        this.warning = addMessage('warning');
        this.info = addMessage('info');
        this.error = addMessage('danger');

        this.setAllDisplayed = function() {
            angular.forEach(this.messages, function(message) {
                message.displayed = true;
            });
        };

        this.clear = function() {
            var messages = [];
            angular.forEach(this.messages, function(message) {
                if (!message.displayed) {
                    messages.push(message);
                }
            });
            this.messages = messages;
        };
    });

})();
